import { createContext, useEffect, useReducer } from "react";
import LangReducer from "./LangReducer";

const INITIAL_STATE = {
  lang: JSON.parse(localStorage.getItem("lang")) || "fr",
};

export const LangContext = createContext(INITIAL_STATE);

export const LangContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(LangReducer, INITIAL_STATE);
  
  useEffect(()=>{
    localStorage.setItem("lang", JSON.stringify(state.lang))
  },[state.lang])
  
  return (
    <LangContext.Provider
      value={{
        lang: state.lang,
        dispatch,
      }}
    >
      {children}
    </LangContext.Provider>
  );
};